import React from 'react'

import TaskList from '../../components/jobTask'

const Details = (props) => {
  return (
    <TaskList task={props.record} />
  )
}

export default Details
